import {PlayerSession} from '../interfaces';
import {getMax, getMean, getSum} from './mathService';

export const getPlayersTeamGroupSessionTotals = (
  playerSessionsData: PlayerSession[],
) => {
  if (!playerSessionsData.length) {
    return null;
  }
  const firstSession = [...playerSessionsData].sort((a, b) => {
    return (
      new Date(a.startTime as string).getTime() -
      new Date(b.startTime as string).getTime()
    );
  })[0];

  const teamSessionTotals = {
    startTime: playerSessionsData.reduce((acc, curr) => {
      const currentStartTime = curr.startTime
        ? new Date(curr.startTime)
        : new Date();
      return (acc = currentStartTime < acc ? currentStartTime : acc);
    }, new Date()),
    localDisplayStartTime: new Date(
      firstSession?.localDisplayStartTime ?? firstSession?.startTime ?? '',
    ),
    timeZone: firstSession?.timeZone,
    strideCountLeft: getSum(
      playerSessionsData.map(ps => ps.strideCountLeft ?? 0),
    ),
    strideCountRight: getSum(
      playerSessionsData.map(ps => ps.strideCountRight ?? 0),
    ),
    activeTime: getSum(playerSessionsData.map(ps => ps.activeTime ?? 0)),
    timeOnIce: getSum(playerSessionsData.map(ps => ps.timeOnIce ?? 0)),
    strintTotalTime: getSum(
      playerSessionsData.map(ps => ps.strintTotalTime ?? 0),
    ),
    strintFilteredStrideRateAvgV2:
      getMean(
        playerSessionsData
          .filter(ps => ps.strintFilteredStrideRateAvgV2)
          .map(ps => ps.strintFilteredStrideRateAvgV2 as number),
      ) ?? null,
    strintFilteredStrideRateMaxV2:
      getMax(
        playerSessionsData
          .filter(ps => ps.strintFilteredStrideRateMaxV2)
          .map(ps => ps.strintFilteredStrideRateMaxV2 as number),
      ) ?? null,
    points: getSum(playerSessionsData.map(ps => ps.points ?? 0)),
    hustleScoreTopLevel:
      getMean(
        playerSessionsData
          .filter(ps => ps.hustleScoreTopLevel)
          .map(ps => ps.hustleScoreTopLevel),
      ) ?? null,
    hustleScore:
      getMean(
        playerSessionsData
          .filter(ps => ps.hustleScore)
          .map(ps => ps.hustleScore),
      ) ?? null,
    speedAvgV2:
      getMean(
        playerSessionsData
          .filter(ps => ps.speedAvgV2)
          .map(ps => ps.speedAvgV2 as number),
      ) ?? null,
    speedMaxV2:
      getMax(
        playerSessionsData
          .filter(ps => ps.speedMaxV2)
          .map(ps => ps.speedMaxV2 as number),
      ) ?? null,
    accelAvgV2:
      getMean(
        playerSessionsData
          .filter(ps => ps.accelAvgV2)
          .map(ps => ps.accelAvgV2 as number),
      ) ?? null,
    accelMaxV2:
      getMax(
        playerSessionsData
          .filter(ps => ps.accelMaxV2)
          .map(ps => ps.accelMaxV2 as number),
      ) ?? null,
    balance:
      getMean(
        playerSessionsData
          .filter(ps => ps.balance)
          .map(ps => ps.balance as number),
      ) ?? null,
    balanceNormalized:
      getMean(
        playerSessionsData
          .filter(ps => ps.balanceNormalized)
          .map(ps => ps.balanceNormalized as number),
      ) ?? null,
    hrAvg:
      getMean(
        playerSessionsData.filter(ps => ps.hrAvg).map(ps => ps.hrAvg as number),
      ) ?? null,
    energyRatio:
      getMean(
        playerSessionsData
          .filter(ps => ps.energyRatio)
          .map(ps => ps.energyRatio as number),
      ) ?? null,
    type: playerSessionsData[0].type,
  };
  return teamSessionTotals;
};
